import { Injectable, Inject, PLATFORM_ID, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class JsonLdService {
  private renderer: Renderer2;
  private isBrowser: boolean;

  constructor(
    rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private doc: Document,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.isBrowser = isPlatformBrowser(platformId);
  }

  setJsonLd(id: string, schema: unknown): void {
    if (!id || !this.doc) return;

    const head = this.doc.head;
    if (!head) return;

    const scriptId = `jsonld-${id}`;

    const existing = this.doc.getElementById(scriptId);
    let scriptEl: HTMLScriptElement;

    if (existing && existing.tagName.toLowerCase() === 'script') {
      scriptEl = existing as HTMLScriptElement;
    } else {

      scriptEl = this.renderer.createElement('script') as HTMLScriptElement;
      this.renderer.setAttribute(scriptEl, 'id', scriptId);
      this.renderer.setAttribute(scriptEl, 'type', 'application/ld+json');
      this.renderer.appendChild(head, scriptEl);
    }

    scriptEl.textContent = this.safeStringify(schema);
  }

  removeJsonLd(id: string): void {
    if (!id || !this.doc) return;

    const el = this.doc.getElementById(`jsonld-${id}`);
    if (el?.parentNode) el.parentNode.removeChild(el);
  }

  private safeStringify(data: unknown): string {
    try {
      return JSON.stringify(data, null, 0);
    } catch {
      return '{}';
    }
  }
}
